import ua from '../util/ua';
import convertToArray from './convertToArray';

class PeriodSelector {
  init() {
    this.doc = document;
    this.dialog = this.doc.getElementById('periodSelectDialog');
    this.customBtn = this.doc.getElementById('periodSelectCustomBtn');
    this.selectItemAttr = 'data-period-item';
    this.selectItem = convertToArray(this.doc.querySelectorAll(`[${this.selectItemAttr}]`));
    this.selectItemLen = this.selectItem.length;
    this.custom = this.doc.getElementById('periodSelectCustom');
    this.backdrop = this.doc.getElementById('backdrop');
    this.activeDialogClass = 'is_active';
    this.activeCustomClass = 'is_active';
    this.activeBackdropClass = 'is_active_transparent';
    this.uaPc = !ua.Mobile && !ua.Tablet;
    this.show = this.show.bind(this);
    this.hide = this.hide.bind(this);
    this.showCustom = this.showCustom.bind(this);
    this.hideCustom = this.hideCustom.bind(this);
    this.addPullDown = this.addPullDown.bind(this);
    this.removePullDown = this.removePullDown.bind(this);
    this.pullDown = this.pullDown.bind(this);
    this.pullDownFocus = this.pullDownFocus.bind(this);
    this.escape = this.escape.bind(this);
  }
  start() {
    this.btn = document.getElementById('periodSelectBtn');
    if (!this.btn) return;
    this.init();
    this.btn.addEventListener('click', this.show);
    if (this.uaPc) {
      this.btn.addEventListener('focus', this.addPullDown);
      this.btn.addEventListener('blur', this.removePullDown);
    }
  }
  show() {
    this.dialog.classList.add(this.activeDialogClass);
    this.backdrop.classList.add(this.activeBackdropClass);
    this.backdrop.addEventListener('click', this.hide);
    this.doc.addEventListener('keydown', this.escape);
    this.customBtn.addEventListener('click', this.showCustom);
  }
  hide() {
    this.dialog.classList.remove(this.activeDialogClass);
    this.backdrop.classList.remove(this.activeBackdropClass);
    this.backdrop.removeEventListener('click', this.hide);
    this.doc.removeEventListener('keydown', this.escape);
    this.customBtn.removeEventListener('click', this.showCustom);
    this.doc.removeEventListener('keydown', this.pullDownFocus);
  }
  showCustom() {
    this.custom.classList.add(this.activeCustomClass);
    for (let i = 0; i < this.selectItemLen - 1; i += 1) {
      this.selectItem[i].addEventListener('click', this.hideCustom);
    }
  }
  hideCustom() {
    this.custom.classList.remove(this.activeCustomClass);
    for (let i = 0; i < this.selectItemLen - 1; i += 1) {
      this.selectItem[i].removeEventListener('click', this.hideCustom);
    }
  }
  addPullDown() {
    this.btn.addEventListener('keydown', this.pullDown);
  }
  removePullDown() {
    this.btn.removeEventListener('keydown', this.pullDown);
  }
  pullDown(e) {
    if (e.keyCode === 40) {
      this.show();
      this.doc.addEventListener('keydown', this.pullDownFocus);
      this.dialog.childNodes[0].focus();
    }
  }
  pullDownFocus(e) {
    if (e.keyCode === 38) {
      const previousElement = this.doc.activeElement.previousElementSibling;
      if (!previousElement) return;
      previousElement.focus();
    }
    if (e.keyCode === 40) {
      const nextElement = this.doc.activeElement.nextElementSibling;
      if (!nextElement) return;
      nextElement.focus();
    }
  }
  escape(e) {
    if (e.keyCode === 27) {
      this.hide();
    }
  }
}
export default PeriodSelector;



// WEBPACK FOOTER //
// ./src/js/module/PeriodSelector.js